module.exports = __webpack_public_path__ + "static/media/mouse.cba8ff4a.jpeg";